var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_box",style:(_vm.styleMerge)},[_c('div',{staticClass:"current-active"}),(_vm.viewData.textarea)?_c('div',[_vm._v(" "+_vm._s(_vm.viewData.textarea)+" ")]):_c('div',[_vm._v(" 请输入文本提示内容 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }